import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { configureStore, combineReducers } from "@reduxjs/toolkit";

import AuthSlice from "./slices/AuthSlice";
import ChatBotsSlice from "./slices/ChatBotsSlice";
import ChatBoxSlice from "./slices/ChatBoxSlice";
import DoctorSlice from "./slices/DoctorSlice";
import DomSlice from "./slices/DomSlice";
import LLMSlice from "./slices/LLMSlice";
import RoadmapsSlice from "./slices/RoadmapsSlice";
import ToolSlice from "./slices/ToolSlice";
import UserSlice from "./slices/UserSlice";
import ChamberSlice from './slices/ChamberSlice';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['chatBots', "tools","users","doctors","chambers"]
}

const rootReducer = combineReducers({
    chatBots: ChatBotsSlice,
    user: AuthSlice,
    dom: DomSlice,
    chatbox: ChatBoxSlice,
    llm: LLMSlice,
    roadMaps: RoadmapsSlice,
    tools: ToolSlice,
    users: UserSlice,
    doctors: DoctorSlice,
    chambers : ChamberSlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
});

export const persistedStore = persistStore(store)

